import { supabase } from '@/lib/supabase';
import { newId } from '@/lib/id';

/**
 * העלאת תמונה לבדל public-media (מיגרציה 025).
 *
 * הבדל משותף לתמונות מוצרים, כריכות לומדות ותמונות מצטיינים, ולכן
 * התיקייה הראשונה בנתיב אומרת למי הקובץ שייך.
 */

const MAX_BYTES = 10 * 1024 * 1024;

export async function uploadImage(folder: 'products' | 'courses' | 'awards' | 'ops', file: File) {
  if (file.size > MAX_BYTES) {
    throw new Error(`התמונה ${(file.size / 1024 / 1024).toFixed(1)} מגה, והמקסימום הוא 10 מגה.`);
  }

  // שם אקראי ולא שם הקובץ: שמות בעברית עם רווחים נשברים בדרך, ושתי
  // תמונות בשם "מוצר.jpg" היו דורסות זו את זו
  const ext = file.type.split('/')[1]?.replace('jpeg', 'jpg') ?? 'jpg';
  const path = `${folder}/${newId()}.${ext}`;

  const { error } = await supabase.storage.from('public-media').upload(path, file, {
    contentType: file.type || 'image/jpeg',
    upsert: false,
  });
  if (error) throw error;
  return path;
}
